(function () {
  var isCollection =
    document.body.classList.contains("template-collection") ||
    window.location.pathname.indexOf("/collections/") !== -1;

  if (!isCollection) return;

  function normalize(str) {
    return (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function getCollectionTitle() {
    var el =
      document.querySelector("h1") ||
      document.querySelector("[data-collection-title]") ||
      document.querySelector(".collection-title");

    if (el && el.textContent) {
      return el.textContent.trim();
    }

    var parts = window.location.pathname.split("/").filter(Boolean);
    var idx = parts.indexOf("collections");
    return idx > -1 && parts[idx + 1] ? parts[idx + 1] : "";
  }

  var rawTitle = getCollectionTitle();
  if (!rawTitle) return;

  rawTitle = rawTitle
    .replace(/^shop by color[:\s-]+/i, "")
    .replace(/^color[:\s-]+/i, "");

  var targetNorm = normalize(rawTitle);
  if (!targetNorm) return;

  var COLOR_MAP = {
    "navy blue": "Navy Blue",
    "royal blue": "Royal Blue",
    "hot pink": "Hot Pink",
    "light blue": "Royal Blue"
  };

  var targetOptionValue = COLOR_MAP[targetNorm] || rawTitle;

  function trySelect(card) {
    var radios = card.querySelectorAll("input[type='radio']");
    if (!radios.length) return;

    var target = normalize(targetOptionValue);

  function splitColors(val) {
    // supports "silver/black", "silver / black", "silver & black"
    return (val || "")
      .toString()
      .replace(/&/g, "/")
      .split("/")
      .map(function (p) {
        return normalize(p.trim());
      })
      .filter(Boolean);
  }

    function rankValue(val) {
    var n = normalize(val);
    if (!n) return 999;

    // 0 = exact match "black"
    if (n === target) return 0;

    var parts = splitColors(val);
    if (!parts.length) return 999;

    // 1 = "black/xxx" (target first)
    if (parts[0] === target) return 1;

    // 2 = "xxx/black" (target included, later)
    var idx = parts.indexOf(target);
    if (idx > 0) return 2;

    return 999;
    }

    var match = null;
    var bestRank = 999;

    for (var i = 0; i < radios.length; i++) {
    var r = radios[i];
    var rank = rankValue(r.value);

    // If multiple matches of same rank, keep the first one encountered
    if (rank < bestRank) {
        bestRank = rank;
        match = r;

        // Early exit if exact match found
        if (bestRank === 0) break;
    }
    }


    if (!match) return;

    if (!match.checked) {
      match.checked = true;
      match.dispatchEvent(new Event("input", { bubbles: true }));
      match.dispatchEvent(new Event("change", { bubbles: true }));
    }

    var variantId =
      match.getAttribute("data-variant-id") ||
      match.getAttribute("data-first-available-or-first-variant-id");

    if (!variantId) return;

    var link = card.querySelector("a[href*='/products/']");
    if (!link) return;

    var url = new URL(link.href, window.location.origin);
    url.searchParams.set("variant", variantId);
    link.href = url.toString();
  }

  var cards = document.querySelectorAll(
    ".product-card, .card-wrapper, .grid__item"
  );

  for (var c = 0; c < cards.length; c++) {
    trySelect(cards[c]);
  }

  var grid =
    document.querySelector(".product-grid") ||
    document.querySelector(".grid");

  if (!grid) return;

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches(".product-card, .card-wrapper, .grid__item")
        ) {
          trySelect(node);
        } else {
          var nested = node.querySelectorAll(
            ".product-card, .card-wrapper, .grid__item"
          );
          for (var i = 0; i < nested.length; i++) {
            trySelect(nested[i]);
          }
        }
      });
    });
  });

  observer.observe(grid, { childList: true, subtree: true });
})();
